const HeroSliderImgs = [
  "./imgs/hero-imgs/img1.webp",
  "./imgs/hero-imgs/img2.webp",
  "./imgs/hero-imgs/img3.webp",
];

export default HeroSliderImgs;
